import moment from 'moment';
import 'moment-timezone';
import StatusQueue from './statusQueue';

const mode = {
	status: 'status',
	announcement: 'announcement',
};

// eslint-disable-next-line no-magic-numbers
const interval = 1000 * 10;
// eslint-disable-next-line no-magic-numbers
const maxAge = moment.duration(12, 'hours');
const maxStatusNumber = 10;
const maxAnnouncementsNumber = 30;

export default class StatusManager {
	constructor(initialStatuses, component, onStatusRemoved) {
		this.mode = mode.status;
		this.component = component;

		// please do not change the order of creation, or the tests would have to be updated
		this.statusQueue = new StatusQueue({
			interval: interval,
			maxStatusAge: maxAge,
			maxStatusNumber: maxStatusNumber, 
			component: {
				showStatus: component.showStatus,
				updateActiveMoment: component.updateActiveMoment,
			},
		}, initialStatuses);

		this.announcementQueue = new StatusQueue({
			interval: interval,
			maxStatusAge: maxAge,
			maxStatusNumber: maxAnnouncementsNumber, 
			checkEndDate: true,
			onQueueEmpty: this.onAnnouncementsQueueEmpty.bind(this),
			onStatusRemoved: onStatusRemoved,
			nonExpiring: true,
			component: {
				showStatus: component.showAnnouncement,
				updateActiveMoment: component.updateActiveMoment,
			},
		});
	}

	get hasItems() {
		return this.queue.length;
	}

	get currentQueue() {
		return this.mode === mode.status ? this.statusQueue : this.announcementQueue;
	}

	get otherQueue() {
		return this.mode === mode.status ? this.announcementQueue : this.statusQueue;
	}

	start() {
		this.currentQueue.start();
	}

	addStatus(status) {
		this.statusQueue.addStatus(status);
	}

	addAnnouncement(status) {
		if (this.mode === mode.status) {
			this.changeMode(mode.announcement);
		}

		this.announcementQueue.addStatus(status);
	}

	removeAnnouncement(id) {
		this.announcementQueue.removeStatus(id);
	}

	onAnnouncementsQueueEmpty() {
		this.changeMode(mode.status);
		if (!this.currentQueue.hasItems) {
			this.component.showStatus();
		}
	}

	changeMode(nextMode) {
		this.mode = nextMode;
		this.otherQueue.stop();
		this.currentQueue.start();
	}
	
	stop() {
		this.currentQueue.stop();
		this.otherQueue.stop();
	}
}
